import { OrganisationService } from "@js/services/OrganisationService";
import {
  ApplicantRoleEnum,
  ApplicationUser,
  ApplicationUserCrudClient,
  BrickflowEventLogClient,
  Client,
  ClientClient,
  HubspotContactRequest,
  IntroducerTypeEnum,
  LenderClient,
  Organisation,
  OrganisationClient,
  OrganisationLink,
  PostalAddress,
  ProductFamilyEnum,
  ProductTypeEnum,
  UserClient,
  UserRoleEnum,
} from "@src/apis/ModularClient";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class InitialRegistrationController {
  selectedType: number;

  RoleEnum = {
    All: 0,
    DevelopmentFinance: 1,
    BridgingFinance: 2,
    Clients: 3,
  };

  user: ApplicationUser;
  client: Client;
  isBroker: boolean = false;
  projectName: string;

  error: string = "";
  registrationForm: ng.IFormController;
  isBorrower: boolean = false;
  panelHeaderText: string;
  dataLoading: boolean = false;
  totalLenders: number = 0;
  orgLogo: string = "";
  testimonialText: string = "";
  testimonalCustomer: string = "";
  showTsAndCs: boolean = false;
  acceptTerms: boolean = false;
  acceptDataTerms: boolean = false;
  showPrivacyPolicy: boolean = false;
  orgCode: string;
  headingAdjustment: string;
  organisation: Organisation;
  userRole: UserRoleEnum;
  organisationLink: OrganisationLink;
  clientId: number;

  static $inject = [
    "$routeParams",
    "$location",
    "UserClient",
    "OrganisationService",
    "OrganisationClient",
    "$rootScope",
    "LenderClient",
    "$cookies",
    "BrickflowEventLogClient",
    "ClientClient",
    "ApplicationUserCrudClient",
    "ODataHelper",
  ];

  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private $location: ng.ILocationService,
    private userClient: UserClient,
    private organisationService: OrganisationService,
    private organisationClient: OrganisationClient,
    public $rootScope: ng.IRootScopeService,
    private lenderClient: LenderClient,
    private $cookies: ng.cookies.ICookiesService,
    private eventLogClient: BrickflowEventLogClient,
    private clientClient: ClientClient,
    private applicationUserCrudClient: ApplicationUserCrudClient,
    private odataHelper: ODataHelper,
  ) {
    this.setBrokerOrBorrower()
      .then(() => {
        if (this.$routeParams.isBroker == "broker") {
          this.isBroker = true;
          sessionStorage.setItem("userRole", UserRoleEnum.Broker.toString());
          //TODO Change for New pricing
          window.location.assign("https://brickflow.com/pricing");
        } else if (this.$routeParams.isBroker == "borrower") {
          this.$location.path("/borrowerinitialregistration");
        } else if (this.$location.path().startsWith("/borrowerinitialregistration")) {
          if (this.$routeParams["Type"] == "bridging") {
            this.$location.path("/e/bridgingcriteria");
          } else {
            this.$location.path("/e/devfinancecriteria");
          }
        } else {
          //TODO Change for New pricing
          window.location.assign("https://brickflow.com/pricing");
        }

        this.getNumberOfLenders();

        //var orgCode;

        if (window.self == window.top) {
          this.orgCode = this.$cookies.get("org_code");
        } else {
          this.orgCode = location.pathname.replace("/", "");
        }

        if (this.orgCode) {
          this.initialRegisterEventLog(this.orgCode);

          this.organisationClient.findOrganisationByOrgCode(this.orgCode).then((organisation: Organisation) => {
            this.organisation = organisation;
            if (this.organisation && organisation.logoURL) {
              this.orgLogo = organisation.logoURL;
            }
          });
        } else {
          this.organisationClient.getBrickflowBrokerOrg().then((organisation: Organisation) => {
            this.organisation = organisation;
          });
          this.initialRegisterEventLog("");
        }

        if (window.self == window.top) {
          if (sessionStorage.getItem("userDetails")) {
            let data = sessionStorage.getItem("userDetails");
            this.user = JSON.parse(data);
          }
        }

        var applicationName = this.getApplicationName();

        if (this.isBroker == true) {
          this.panelHeaderText = "Welcome to " + applicationName + " for Brokers";
          if (!this.user) {
            this.user = {
              // I think this can go, but not sure
              // roles: ["Broker", "Introducer"],
              isOrganisationAdmin: true,
              applicantDefinedRole: ApplicantRoleEnum.Introducer,
              applicantDefinedRoleIntroducer: IntroducerTypeEnum.Broker,
            } as ApplicationUser;
          }
        }
      })
      .catch((error) => {
        console.error("Failed to get initialize data: ", error);
      });
  }

  async getUserRole(): Promise<void> {
    if (window.self == window.top) {
      this.userRole = parseInt(sessionStorage.getItem("userRole")) as UserRoleEnum;
    } else {
      this.organisationService.getData("userRole").then((result) => {
        this.userRole = Number(result) as UserRoleEnum;
      });
    }
  }

  async setBrokerOrBorrower() {
    await this.getUserRole();
    this.isBroker = this.userRole === UserRoleEnum.Broker;
    this.isBorrower = this.userRole === UserRoleEnum.Client;
  }

  async initialRegisterEventLog(orgCode, organisationLinkId = null) {
    if (window.self == window.top) {
      if (sessionStorage.getItem("clientId")) {
        this.eventLogClient.logPageLoad(
          "INITIALREGISTER",
          orgCode,
          "",
          sessionStorage.getItem("userRole"),
          organisationLinkId,
          this.$routeParams["Type"] == "bridging" ? ProductTypeEnum.Bridging : ProductTypeEnum.Development,
          undefined,
          undefined,
          Number(sessionStorage.getItem("clientId")),
        );
      } else {
        this.eventLogClient.logPageLoad(
          "INITIALREGISTER",
          orgCode,
          "",
          sessionStorage.getItem("userRole"),
          organisationLinkId,
          this.$routeParams["Type"] == "bridging" ? ProductTypeEnum.Bridging : ProductTypeEnum.Development,
        );
      }
    } else {
      var userRole;
      userRole = await this.organisationService.getData("userRole");
      var clientId: number = null;
      clientId = Number(await this.organisationService.getData("clientId"));
      if (clientId) {
        this.eventLogClient.logPageLoad(
          "INITIALREGISTER",
          orgCode,
          "",
          sessionStorage.getItem("userRole"),
          organisationLinkId,
          this.$routeParams["Type"] == "bridging" ? ProductTypeEnum.Bridging : ProductTypeEnum.Development,
          undefined,
          undefined,
          clientId,
        );
      } else {
        this.eventLogClient.logPageLoad(
          "INITIALREGISTER",
          orgCode,
          "",
          sessionStorage.getItem("userRole"),
          organisationLinkId,
          this.$routeParams["Type"] == "bridging" ? ProductTypeEnum.Bridging : ProductTypeEnum.Development,
        );
      }
    }
  }

  saveUserdetails() {
    this.dataLoading = true;
    let emailExists: boolean;

    this.odataHelper
      .getOne(this.applicationUserCrudClient, {
        filter: {
          email: {
            eq: this.user.email,
          },
        },
        select: { id: true },
      })
      .then((result) => {
        emailExists = result != null;
        return this.organisationService.getData("userRole");
      })
      .then((role) => {
        if (window.self === window.top) {
          this.userRole = parseInt(sessionStorage.getItem("userRole")) as UserRoleEnum;
        } else {
          this.userRole = parseInt(role) as UserRoleEnum;
        }
        return this.organisationService.getData("clientId");
      })
      .then((id) => {
        if (window.self === window.top) {
          this.clientId = Number(sessionStorage.getItem("clientId"));
        } else {
          this.clientId = Number(id);
        }
        if (emailExists == false) {
          this.processUserDetails(this.userRole, this.clientId);
        } else {
          this.error = "Email address is already in use, please sign in.";
        }
      })
      .catch((error) => {
        console.error("An error occurred in saveUserdetails:", error);
        this.error = "An error occurred while processing your request. Please try again.";
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  processUserDetails(userRole, clientId) {
    this.error = "";
    if (this.isBroker) {
      // this.user.Roles = ["Broker", "Introducer"];
      this.user.isOrganisationAdmin = true;
      (this.user.applicantDefinedRole = ApplicantRoleEnum.Introducer),
        (this.user.applicantDefinedRoleIntroducer = IntroducerTypeEnum.Broker);
    } else {
      // this.user.Roles = ["Client"];
    }
    if (window.self == window.top) {
      sessionStorage.setItem("userDetails", JSON.stringify(this.user));
      sessionStorage.setItem("projectname", this.projectName);
      const hubspotRequest: HubspotContactRequest = {
        user: this.user,
        page: "PREREGISTER",
        login: false,
        orgCode: this.orgCode,
        role: parseInt(sessionStorage.getItem("userRole")) as UserRoleEnum,
        organisationLinkId: this.organisationLink?.isEnabled ? this.organisationLink.id : 0,
        productType: this.$routeParams["Type"] === "bridging" ? ProductTypeEnum.Bridging : ProductTypeEnum.Development,
        dealId: 0,
        developmentInputWithNoLoginUniqueRef: "",
        clientId: this.clientId,
      };

      this.userClient.sendEventToHubspot(hubspotRequest);
    } else {
      this.organisationService.sendDataToParent("userDetails", JSON.stringify(this.user));
      this.organisationService.sendDataToParent("projectname", this.projectName);

      const hubspotRequest: HubspotContactRequest = {
        user: this.user,
        page: "PREREGISTER",
        login: false,
        orgCode: this.orgCode,
        role: this.userRole,
        organisationLinkId: this.organisationLink?.isEnabled ? this.organisationLink.id : 0,
        productType: this.$routeParams["Type"] === "bridging" ? ProductTypeEnum.Bridging : ProductTypeEnum.Development,
        dealId: 0,
        developmentInputWithNoLoginUniqueRef: "",
        clientId: this.clientId,
      };

      this.userClient.sendEventToHubspot(hubspotRequest);
    }

    if (this.isBroker) {
      this.organisationClient.brokerSignUpJourneyG0Email(this.user.email, this.user.fullName).then((response) => {});
    }

    if (this.isBroker) {
      this.$location.path("/promo/true");
    } else {
      (this.$rootScope as any).loanCriteria = null;
      if (this.selectedType == 1) {
        this.$location.path("/devfinancecriteria");
      } else if (this.selectedType == 0) {
        this.saveUserDataToClientTable().then(() => {
          this.$location.path("/newsearchselection/all");
        });
      } else if (this.selectedType == 2) {
        this.saveUserDataToClientTable().then(() => {
          this.$location.path("/bridgingcriteria");
        });
      }
    }
  }

  back() {
    this.$location.path("/landingV3");
  }

  isiframe() {
    if (window.self == window.top) return false;
    return true;
  }

  getApplicationName() {
    if (window.self == window.top && sessionStorage.getItem("applicationName") != null) {
      return sessionStorage.getItem("applicationName");
    } else {
      return "Brickflow";
    }
  }

  getNumberOfLenders() {
    var productType = ProductFamilyEnum.None;

    if (this.selectedType == this.RoleEnum.BridgingFinance) {
      productType = ProductFamilyEnum.Bridging;
    } else if (this.selectedType == this.RoleEnum.DevelopmentFinance) {
      productType = ProductFamilyEnum.Development;
    }

    if (productType == ProductFamilyEnum.None) {
      this.lenderClient.getTotalLenders(ProductFamilyEnum.None).then((response: number) => {
        this.totalLenders = Math.floor(response);
      });
    } else {
      this.lenderClient.getTotalLenders(productType).then((response: number) => {
        this.totalLenders = Math.floor(response);
      });
    }
  }

  genUUID() {
    let S4 = () =>
      Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    let guid = `${S4()}${S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`;
    return guid.toLowerCase();
  }

  saveUserDataToClientTable() {
    return new Promise<void>(async (resolve, reject) => {
      let userFullName = this.user.fullName;
      let spaceIndex = userFullName.indexOf(" ");

      let firstName = "";
      let lastName = "";

      // if not space has been added to the name then put the whole name in the first name field
      if (spaceIndex == -1) {
        firstName = userFullName;
      } else {
        firstName = userFullName.substring(0, userFullName.indexOf(" "));
        lastName = userFullName.substring(userFullName.indexOf(" ") + 1);
      }

      var clientDto = {
        firstName: firstName,
        lastName: lastName,
        phoneNumber: this.user.phoneNumber,
        email: this.user.email,
        brokerOrganisationId: this.organisation.id,
        postalAddress: {
          addressLine1: "",
          addressLine2: "",
          addressLine3: "",
          addressLine4: "",
          postCode: "",
        } as PostalAddress,
      } as Client;

      //if (localStorage.getItem('clientId')) {
      //    clientDto.Id = Number(localStorage.getItem('clientId'));
      //}

      try {
        this.clientClient.addUpdateReturnOnlyID(clientDto).then((response) => {
          if (window.self == window.top) {
            sessionStorage.setItem("clientId", response.toString());
          } else {
            this.organisationService.sendDataToParent("clientId", response.toString());
          }
        });
        resolve();
      } catch (error) {
        console.error("An error occurred:", error);
        Promise.reject(error);
      }
    });
  }

  gotoSignInPage() {
    this.$location.path("/login");
  }
}
